import React from 'react';
import OptionButton from '../shared/OptionButton';
import { ProgrammeType } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const options = [
  { label: '5K', value: ProgrammeType.FIVE_K },
  { label: '10K', value: ProgrammeType.TEN_K },
  { label: 'Half Marathon', value: ProgrammeType.HALF_MARATHON },
  { label: 'Marathon', value: ProgrammeType.MARATHON },
  { label: 'Ultra Marathon', value: ProgrammeType.ULTRA_MARATHON },
  { label: 'Something else', value: ProgrammeType.SOMETHING_ELSE },
  { label: 'No specific distance', value: ProgrammeType.NONE },
];

const ProgrammeTypeStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {options.map((opt) => (
        <OptionButton
          key={opt.value}
          label={opt.label}
          value={opt.value}
          selected={answer === opt.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default ProgrammeTypeStep;
